import { render, staticRenderFns } from "./ShortcutsOverlay.vue?vue&type=template&id=42102402&scoped=true"
import script from "./ShortcutsOverlay.vue?vue&type=script&lang=js"
export * from "./ShortcutsOverlay.vue?vue&type=script&lang=js"
import style0 from "./ShortcutsOverlay.vue?vue&type=style&index=0&id=42102402&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42102402",
  null
  
)

export default component.exports